module.exports = __webpack_public_path__ + "static/media/nutritionorder.js.4366b9e9.map";